import { TFunction } from 'i18next';
import { SelectItem } from 'src/theming';

export enum WHO_DISCHARGED_OPTIONS {
    SENDER = 'Sender',
    DRIVER = 'Driver',
    OTHER = 'Other',
}

export const generateWhoDischargedSelectionsOptions = (t: TFunction): SelectItem[] => {
    return [
        {
            title: t('damages-report:noChoice'),
            value: 'No choice',
        },
        {
            title: t('damages-report:whoLoadedOptions.sender'),
            value: WHO_DISCHARGED_OPTIONS.SENDER,
        },
        {
            title: t('damages-report:whoLoadedOptions.driver'),
            value: WHO_DISCHARGED_OPTIONS.DRIVER,
        },
        {
            title: t('damages-report:whoLoadedOptions.other'),
            value: WHO_DISCHARGED_OPTIONS.OTHER,
        },
    ];
};
